import { render, staticRenderFns } from "./LiveDrop.vue?vue&type=template&id=0ac2e83c&"
import script from "./LiveDrop.vue?vue&type=script&lang=ts&"
export * from "./LiveDrop.vue?vue&type=script&lang=ts&"
import style0 from "./LiveDrop.vue?vue&type=style&index=0&id=0ac2e83c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports